import { render } from "./AiChatGemini.vue?vue&type=template&id=7ad58258&ts=true"
import script from "./AiChatGemini.vue?vue&type=script&lang=ts"
export * from "./AiChatGemini.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__